import { Loader } from "@partners/ui";
import { createFileRoute } from "@tanstack/react-router";

import {
  AUTH_ERROR_TEXT,
  AUTH_REDIRECT_ERROR_TEXT,
  AuthError,
} from "@/components/Error";
import { logger } from "@/utils/logger";

export const Route = createFileRoute("/signup")({
  errorComponent: AuthError,
  pendingComponent: () => <Loader />,
  validateSearch: (search: Record<string, unknown>) => ({
    redirectTo:
      typeof search.redirectTo === "string" && search.redirectTo.startsWith("/")
        ? search.redirectTo
        : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.error) {
      logger.error(context.auth.error);
      throw new Error(AUTH_ERROR_TEXT);
    }
    void context.auth.loginWithRedirect({
      appState: { returnTo: search.redirectTo ?? "/program-selection" },
      authorizationParams: {
        screen_hint: "signup",
      },
    });
    throw new Error(AUTH_REDIRECT_ERROR_TEXT);
  },
});
